export function convertToCurrencyValue(value: string): string {
  const normalizeValue = value
    .replace(/\./g, '')
    .replace(',', '')
    .replace(/\D/g, '');

  if (normalizeValue == '') return '';

  const options = {
    minimumFractionDigits: 2,
    style: 'currency',
    currency: 'BRL',
  };
  const result = new Intl.NumberFormat('pt-BR', options).format(
    parseFloat(normalizeValue) / 100
  );
  return result;
}

export function convertCurrencyToCents(value: string): string {
  const normalizeValue = value
    .replace(/\./g, '')
    .replace(',', '')
    .replace(/\D/g, '');

  return normalizeValue;
}

export function formatPhoneNumber(number) {
  return number.replace(/[^\d+]/g, '');
}

export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};
